import Loader from 'src/components/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import Table from 'src/components/Table';
import { OccupancyReportData } from 'src/pages/Reporting/ReportingFormTypes';

interface OccupancyDeficiencyTableProps {
  reports: OccupancyReportData[];
  isLoading: boolean;
}

const OccupancyDeficiencyTable = ({
  reports,
  isLoading,
}: OccupancyDeficiencyTableProps) => {
  const columns: any = [
    {
      label: 'Property Name',
      cell: (data: OccupancyReportData) => data.propertyName,
    },
    {
      label: 'Unit',
      cell: (data: OccupancyReportData) => data.unitNumber,
    },
    {
      label: 'Building',
      cell: (data: OccupancyReportData) => data.building,
    },
    {
      label: 'Count of Internal Walkthrough Service Requests',
      cell: (data: OccupancyReportData) =>
        data.internalWalkthroughServiceRequestsCount,
    },
    {
      label: 'Count of Homeowner Walkthrough Service Requests',
      cell: (data: OccupancyReportData) =>
        data.homeOwnerWalkthroughServiceRequestsCount,
    },
    {
      label: 'Count of Warranty Service Requests',
      cell: (data: OccupancyReportData) => data.warrantyServiceRequestsCount,
    },
    {
      label: '% of Internal Walkthrough Service Requests',
      cell: (data: OccupancyReportData) =>
        `${data.internalWalkthroughServiceRequestsPercentage}%`,
    },
    {
      label: '% of Homeowner Walkthrough Service Requests',
      cell: (data: OccupancyReportData) =>
        `${data.homeOwnerWalkthroughServiceRequestsPercentage}%`,
    },
    {
      label: '% of Warranty Service Requests',
      cell: (data: OccupancyReportData) =>
        `${data.warrantyServiceRequestPercentage}%`,
    },
  ];

  return (
    <div>
      {reports.length > 0 && <h3>Stats by Units</h3>}
      {isLoading && (
        <div className="loader-container">
          <Loader center={true} />
        </div>
      )}
      {reports && reports.length > 0 && (
        <div id="scrollableDiv" className="scrollable-container">
          <InfiniteScroll
            dataLength={reports.length}
            style={{ display: 'flex', flexDirection: 'column' }}
            inverse={false}
            hasMore={false}
            loader={<div>Loading...</div>}
            scrollableTarget="scrollableDiv"
            next={() => {}}
          >
            <Table
              columns={columns}
              data={reports}
              defaultSort={undefined}
              headerTop={undefined}
            />
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
};

export default OccupancyDeficiencyTable;
